<template>
    <div class="vld-parent">
        <div v-if="bool_isAMV == true">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto" ref="addImage">
                    <div style="width:90%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">Add Accounting Report</h4> <CButton size="sm" color="outline-info" @click="addList()"> <span class='plusIcon cil-plus'></span> {{getLanguage["BTN"]["AN"]}}</CButton>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="bool_isAMV =!bool_isAMV">

                                            <CIcon name=cilX></CIcon>

                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div style="text-align:left;margin-top:20px; margin-bottom:30px;">
                                    <div class='searchBox'>
                                        <div class='searchCol'>
                                            <label class="searchLabel">{{this.getLanguage["MT"]["BN"]}} :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroupfs"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :placeholder="getLanguage['MT']['BN']"
                                                              @input="AgentGroupChangefs"
                                                              v-model="agit" />
                                        </div>
                                        <div class='searchCol'>
                                            <span class='searchLabel'>{{this.getLanguage["AFF"]["PD"]}} :</span>
                                            <vue-monthly-picker v-model="YearMonth"
                                                                :clearOption="false"
                                                                selectedBackgroundColor="blue">
                                            </vue-monthly-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-main-content" ref="capture">
                                    <div class="invoice-container">
                                        <div class="left-section">
                                            <h5 class="fw-bold">INVOICE TO</h5>
                                            <p class="recipient-name">William SM</p>
                                            <div class="empty-line"></div>
                                            <p>P: -</p>
                                            <p>E: -</p>
                                        </div>
                                        <div class="right-section">
                                            <h1>I N V O I C E</h1>
                                            <div class="invoice-details">
                                                <p><strong>Invoice:</strong> <span>02240006</span></p>
                                                <p><strong>Account:</strong> <span>-</span></p>
                                                <p><strong>Invoice:</strong> <span>4 Mar 2024</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <table class="custom-table custom-table-inPopUp2 afb-blue">
                                        <thead>
                                            <tr>
                                                <th>NO</th>
                                                <th>Item Description</th>
                                                <th>Quantity</th>
                                                <th>CUR</th>
                                                <th>Amount</th>
                                                <th>Exchange Rate</th>
                                                <th>Amount (USD)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in accoutingList" :key="item.id">
                                                <td>
                                                    {{ index + 1 }}
                                                    <div class="custom_tooltip delete-icon-container" @click="deleteItem(index)">
                                                        <i class="cil-trash"></i>
                                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                    </div>
                                                </td>
                                                <td>{{ item.description }}</td>
                                                <td>{{ item.quantity !== null ? item.quantity : '-' }}</td>
                                                <td>{{ item.currency }}</td>
                                                <td>{{ item.amount1.toFixed(2) }}</td>
                                                <td>{{ item.rate.toFixed(2) }}</td>
                                                <td class="tableCtnRight">{{ item.amount2.toFixed(2) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="summary-container">
                                        <div class="summary">
                                            <div class="invoice">
                                                <div class="total-due">
                                                    <p>TOTAL DUE: <span class="amount">{{ totalAmount2 }}</span></p>
                                                </div>
                                                <div class="breakdown">
                                                    <p>Subtotal: <span class="amount">{{ totalAmount2 }}</span></p>
                                                    <p>Tax Rate: <span class="amount">0.00</span></p>
                                                    <p>Others: <span class="amount">0.00</span></p>
                                                    <div class="grand-total">
                                                        <p>GRAND TOTAL: <span class="amount">{{ totalAmount2 }}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-dark" size="sm">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["GL"]["P"]}}
                                    </CButton>
                                    <CButton color="outline-primary" size="sm">
                                        <span class='plusIcon cil-lock-locked'></span>
                                        {{this.getLanguage["FR"]["SOFF"]}}
                                    </CButton>
                                    <CButton color="outline-info" size="sm">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="bool_isAMV1 == true">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto" ref="addImage">
                    <div style="width:70%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">Add Accouting List</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="bool_isAMV1 =!bool_isAMV1">
                                                
                                            <CIcon name=cilX></CIcon>

                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div style="text-align:left;margin-top:20px; margin-bottom:30px;">
                                    <div class='searchBox'>
                                        <CCol col="5" class="form-group">
                                            <label class="searchLabel">{{this.getLanguage["MT"]["BN"]}} :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroupfs"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :placeholder="getLanguage['MT']['BN']"
                                                              @input="AgentGroupChangefs"
                                                              v-model="agit"
                                                              :disabled=true />
                                        </CCol>
                                        <CCol col="5" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["IDT"]}}<span class="required" />: </label>
                                            <textarea v-shortkey.avoid vertical="" rows="1" class="form-control form-control-sm" v-model="accoutingItem.description" />
                                        </CCol>
                                        <CCol col="2" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{this.getLanguage["AG"]["QUANT"]}}<span class="required" /> :
                                            </label>
                                            <textarea v-shortkey.avoid vertical="" rows="1" class="form-control form-control-sm" v-model="accoutingItem.quantity"/>
                                        </CCol>
                                        <CCol col="4" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{  getLanguageOEMI(this.getUserInfo.OEMI,"TNMT","A") }}<span class="required" /> :</span>
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency"
                                                        :placeholder="getLanguage['AG']['C']"
                                                        @input="CurrencyChange"
                                                        v-model="accoutingItem.CI"
                                                        class="inline inline40"
                                                        :clearable="false"
                                                        ref="CI" />
                                            <CInput :placeholder="getLanguageOEMI(this.getUserInfo.OEMI,'TNMT','A')"
                                                    size="sm"
                                                    class="inline inline60"
                                                    :value="ThousandSeparator(accoutingItem.amount1, getThousandCurrency ? 3 : 2)"
                                                    @change="v => accoutingItem.amount1 = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                                    ref="AMT"></CInput>
                                        </CCol>
                                    </div>
                                </div>
                                <div style="text-align:center;margin-top:10px">
                                    <CButton color="outline-info" size="sm" @click="SaveAccoutingList()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>


                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{checkModuleIndex('ACM', 'R', constAccessType.view, '', 0)}} {{this.getLanguage["SMB"]["ACM"]}}</h2>
                        <CButton size="sm" color="outline-info" @click="addRecord()"> <span class='plusIcon cil-plus'></span> {{getLanguage["BTN"]["AN"]}}</CButton>
                    </div>
                </CCol>
            </CRow>
            <div class="searchForm">
                <div class='searchBox'>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                        <customtreeselect :multiple="true"
                                          :flat="true"
                                          :options="ddAgentList"
                                          :defaultExpandLevel="Infinity"
                                          :disable-branch-nodes="false"
                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                          :limit="1"
                                          :limitText="count => `+${count}`"
                                          valueConsistsOf="LEAF_PRIORITY"
                                          :load-options="loadAgentOptions"
                                          :auto-load-root-options="convertToBool(searchAgent)"
                                          @input="selectAgentOptions"
                                          v-model="searchAgent" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                        <date-range-picker :show-dropdowns="true"
                                           opens="left"
                                           :auto-apply="true"
                                           v-model="searchCreatedTS"
                                           @update="defaultDateRangePickerUpdateEvent"
                                           :ranges="getDefaultDateRange()">
                            <div slot="input" slot-scope="picker">
                                <div v-if="searchCreatedTS.startDate != ''">
                                    <CInput size="sm"
                                            :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                            @change="DateTimeChange('SD',$event)" />
                                </div>
                                <div v-else>
                                    <CInput size="sm"
                                            @change="DateTimeChange('SD',$event)" />
                                </div>
                            </div>
                        </date-range-picker>
                        <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                            <CIcon name="cilX" size="sm"></CIcon>
                        </CButton>
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                        <date-range-picker :show-dropdowns="true"
                                           opens="left"
                                           :auto-apply="true"
                                           v-model="searchCreatedTS"
                                           @update="defaultDateRangePickerUpdateEvent"
                                           :ranges="getDefaultDateRange()">
                            <div slot="input" slot-scope="picker">
                                <div v-if="searchCreatedTS.endDate != ''">
                                    <CInput size="sm"
                                            :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                            @change="DateTimeChange('ED',$event)" />
                                </div>
                                <div v-else>
                                    <CInput size="sm"
                                            @change="DateTimeChange('ED',$event)" />
                                </div>
                            </div>
                        </date-range-picker>
                        <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                            <CIcon name="cilX" size="sm"></CIcon>
                        </CButton>
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>Report Type:</span>
                        <treeselect :multiple="false"
                                    :options="ddReportTypeFilter"
                                    :auto-load-root-options="false"
                                    :disable-branch-nodes="true"
                                    v-model="SearchReportTypeFilter" />
                    </div>
                </div>
                <div class='searchBtnCol'>
                    <CButton v-shortkey="['enter']" class='searchBtn' ref="search" size="sm" block color="success"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                </div>
            </div>
            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>Accounting Report List</strong>
                    <div class="pageBtn">
                        <button>
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               type="number"
                               v-shortkey.avoid
                               @keyup="" />
                        <span class="tableItemCount">/ 0</span>
                        <button>
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage[["GL"]]["NO"]}}</th>
                                <th class="tableCtnCenter">{{getLanguage["GL"]["ACT"]}}</th>
                                <th class="tableCtnCenter">{{this.getLanguage["FR"]["YM"]}}<i :class="setSortLogo('Y')" class="sortlogo"></i></th>
                                <th>CUR<i :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">GGR 90%<i :class="setSortLogo('TWL')" class="sortlogo"></i> </th>
                                <th class="tableCtnRight">Total Reimbursement<i :class="setSortLogo('TWL')" class="sortlogo"></i> </th>
                                <th class="tableCtnRight">Carry Forward<i :class="setSortLogo('TWL')" class="sortlogo"></i> </th>
                                <th class="tableCtnRight">Other Expenses<i :class="setSortLogo('TE')" class="sortlogo"></i></th>
                                <th class="tableCtnRight"> {{this.getLanguage["MTA"]["GT"]}} <i :class="setSortLogo('N')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>
                                    <span id="actionBtnCol">
                                        <div>
                                            <i class="cil-description"></i> <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </div>
                                        <div class="custom_tooltip">
                                            <i class="cil-color-border"></i> <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                    </span>
                                </td>
                                <td class="tableCtnRight">2024/Jun</td>
                                <td class="tableCtnRight">USD</td>
                                <td class="tableCtnRight">USD 1300.00</td>
                                <td class="tableCtnRight">USD 2300.00</td>
                                <td class="tableCtnRight">USD 3000.00</td>
                                <td class="tableCtnRight">USD 4000.00</td>
                                <td class="tableCtnRight">USD 10000.00</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>
                                    <span id="actionBtnCol">
                                        <div>
                                            <i class="cil-description"></i> <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </div>
                                        <div class="custom_tooltip">
                                            <i class="cil-color-border"></i> <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                    </span>
                                </td>
                                <td class="tableCtnRight">2024/July</td>
                                <td class="tableCtnRight">MYR</td>
                                <td class="tableCtnRight">RM 1300.00</td>
                                <td class="tableCtnRight">RM 2300.00</td>
                                <td class="tableCtnRight">RM 3000.00</td>
                                <td class="tableCtnRight">RM 4000.00</td>
                                <td class="tableCtnRight">RM 10000.00</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>
                                    <span id="actionBtnCol">
                                        <div>
                                            <i class="cil-description"></i> <!--here Edit -->
                                            <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                        </div>
                                    </span>
                                </td>
                                <td class="tableCtnRight">2024/Aug</td>
                                <td class="tableCtnRight">THB</tdclass="tableCtnRight">
                                <td class="tableCtnRight">THB 1300.00</td>
                                <td class="tableCtnRight">THB 2300.00</td>
                                <td class="tableCtnRight">THB 3000.00</td>
                                <td class="tableCtnRight">THB 4000.00</td>
                                <td class="tableCtnRight">THB 10000.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .summary-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .summary {
        width: 30%;
    }


    .total-due p, .breakdown p, .grand-total p {
        margin: 0;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;
    }

    .grand-total {
        border: 2px solid black;
        padding: 10px;
        margin-top: 20px;
        width: 100%; 
    }

    .amount {
        color: red;
        text-align: right;
        min-width: 100px;
    }

    .delete-icon-container {
        display: none;
        cursor: pointer;
    }

    tr:hover .delete-icon-container {
        display: inline-block;
    }

    .delete-icon {
        width: 16px;
        height: 16px;
        color: red;
    }

    .invoice-container {
        display: flex;
        justify-content: space-between;
        padding: 40px 20px;
        align-items: flex-start;
        width: 100%;
    }

    .left-section {
        width: 30%; 
    }

        .left-section h5,
        .left-section p:not(.recipient-name) {
            color: black;
            font-size: 14px; 
        }

    .recipient-name {
        font-weight: bold;
        font-size: 18px;
        margin-top: -5px;
        color: #2e7d32;
    }

    .empty-line {
        height: 20px;
        margin: 10px 0;
    }

    .right-section {
        text-align: right;
        width: 65%; 
        position: relative;
    }

        .right-section h1 {
            font-size: 36px;
            letter-spacing: 8px;
            color: #2e7d32;
            margin-bottom: 10px;
            margin-top: 0;
        }

    .invoice-details {
        margin-top: 30px;
        text-align: left;
        margin-left: auto;
        width:30%;
    }

        .invoice-details p {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
        }

            .invoice-details p strong {
                text-align: left;
            }

            .invoice-details p span {
                text-align: right;
            }
</style>
    <script>
        import { constPromotionStatus, constRejectReasonP, constPromotionSystemApproved, constAccessType, loadingFullScreen } from '@/modules/Constant.js'
        import DateRangePicker from 'vue2-daterange-picker';
        import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
        import Treeselect from '@riophae/vue-treeselect';
        import { customtreeselect } from '@/views/CustomControl/index.js';
        import '@riophae/vue-treeselect/dist/vue-treeselect.css';
        import Loading from 'vue-loading-overlay';
        import 'vue-loading-overlay/dist/vue-loading.css';
        import { mapGetters, mapActions } from 'vuex';
        import genericHelper from "@/modules/GenericHelper.js";
        import VueMonthlyPicker from 'vue-monthly-picker';
        import moment from "moment";
        import Vue from 'vue'
        //Vue.use(require('vue-shortkey'))
        import $ from 'jquery'
        import draggable from 'vuedraggable';
        export default {
            mixins: [genericHelper],
            components: {
                VueMonthlyPicker,
                DateRangePicker,
                Treeselect,
                customtreeselect,
                Loading,
                draggable
            },
            data() {
                return {
                    bool_isAMV: false,
                    searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                    str_showDetails: "",
                    str_tableSortBy: "Y",
                    bool_isSort: true,
                    SearchReportTypeFilter: null,
                    ddReportTypeFilter: null,
                    searchAgent: null,
                    dd_agentgroupfs: [],
                    dd_currency: [],
                    searchAgT: 0,
                    searchAgi: '',
                    selectedAgent1: null,
                    selectedAgent: null,
                    agit: null,
                    YearMonth: null,
                    ddAgentList: null,
                    bool_isAMV1: false,
                    constAccessType: constAccessType,

                    accoutingList: [
                        {
                            id: 1,
                            description: 'Carry forward',
                            currency: 'MYR',
                            amount1: 1500.00,
                            rate: 4.75,
                            CI: 13,
                            quantity: null,
                            amount2: 0.00
                        },
                        {
                            id: 2,
                            description: 'GGR 90%',
                            currency: 'MYR',
                            amount1: 1500.00,
                            rate: 4.75,
                            CI: 13,
                            quantity: 100,
                            amount2: 0.00
                        },
                        {
                            id: 3,
                            description: 'Tournament Reimbursement',
                            currency: 'MYR',
                            CI: 13,
                            amount1: 1500.00,
                            rate: 4.75,
                            quantity: 50,
                            amount2: 0.00
                        }
                    ],
                    accoutingItem: {
                        id: null,
                        description: '',
                        currency: '',
                        CI:null,
                        amount1: 0.00,
                        rate: 0.00,
                        quantity: 0,
                        amount2: 0.00
                    },
                }
            },
            computed: {
                ...mapGetters('Language', ['getLanguage']),
                ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
                ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
                ...mapGetters('SMBData', ['getCurrencySymbol', 'getSystemBalance', 'getCreditBalance', 'getBalanceStatus', 'getCurrencyCode']),
                totalAmount2() {
                    return this.accoutingList.reduce((total, item) => {
                        return total + item.amount2;
                    }, 0).toFixed(2);
                }
            },
            methods: {
                ...mapActions('SMBData', [
                    'setCurrencySymbol',
                    'setSystemBalance',
                    'setCreditBalance'
                ]),
                ...mapActions('CurrencyInfo', ['setThousandCurrency']),
                deleteItem(index) {
                    this.accoutingList.splice(index, 1); // Remove the item at the given index
                },
                getSelectAgentgroup()
                {
                    var that = this;
                    this.getDataApi(`/api/dd/ag/1/0`,
                        function (d, s) {
                            if (s) {
                                that.dd_agentgroupfs = that.deepClone(d.dropdownlist);
                            }
                        });

                    this.getDataApi('/api/dd/curwr/0',
                        function (d, s) {
                            if (s) {
                                if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                    for (var i = 0; i < d.dropdownlist.length; i++) {
                                        if (d.dropdownlist[i].ICT != true)
                                            that.dd_currency.push(d.dropdownlist[i]);
                                    }
                                }
                            }
                        });
                    console.log('dd_currency', this.dd_currency);
                },
                CurrencyChange(value) {
                    if (value != undefined) {
                        const selectedCurrency = this.dd_currency.find(val => val.id === value);
                        if (selectedCurrency) {
                            this.setThousandCurrency(this.CheckIsThousandCurrency(selectedCurrency.label, this), this);
                            this.accoutingItem.currency = selectedCurrency.label;
                            this.accoutingItem.rate = selectedCurrency.ER; 
                        }
                    }


                },
                getAgentGroup(value) {
                    var that = this;
                    this.getDataApi(`/api/dd/ag/1/0/1`,
                        function (d, s) {
                            if (s) {
                                that.ddAgentList = that.deepClone(d.dropdownlist);
                            }
                        });
                },
                SaveAccoutingList() {
                    this.accoutingItem.amount1 = parseFloat(this.accoutingItem.amount1);
                    console.log('accoutingItem', this.accoutingItem);

                    const newItem = { ...this.accoutingItem }; 
                    newItem.id = this.accoutingList.length + 1; 

                    this.accoutingList.push(newItem);

                    this.accoutingItem = {
                        id: null,
                        description: '',
                        currency: '',
                        CI: null,
                        amount1: 0.00,
                        rate: 0.00,
                        quantity: 0,
                        amount2: 0
                    };
                    this.bool_isAMV1 = false;
                    this.calculateAndStoreAmount2();
                },
                AgentGroupChangefs(value) {
                    if (value == "" || value == null || value == undefined) {
                        this.selectedAgent1 = null;

                    }
                    else {
                        this.selectedAgent1 = value.split("-")[1];
                    }
                },
                selectAgentOptions(value, instanceId) {
                    if (value && value.length > 0) {
                        var agentList = value[0].split("-");
                        this.searchAgT = agentList[agentList.length - 2];
                    }

                    var temp = "";
                    for (var x = 0; x < value.length; x++) {
                        if (x != 0) {
                            temp += ",";
                        }
                        var split = value[x].split("-");

                        if (split.length == 2) {
                            temp += split[1];
                        }
                        else {
                            temp += split[0];
                        }
                    }
                    this.searchAgi = temp;
                    this.selectedAgent = value;
                    this.getAgentGroup();
                },
                calculateAndStoreAmount2() {
                    this.accoutingList.forEach(item => {
                        item.amount2 = item.quantity !== null
                            ? item.quantity * item.amount1 * item.rate
                            : item.amount1 * item.rate;
                    });
                },
                loadAgentOptions({ action, callback, instanceId }) {
                    var that = this;
                    this.getDataApi(`/api/dd/ag/1/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddAgentList = d.dropdownlist;
                            }
                            else {
                                that.ddAgentList = null;
                                that.searchAgT = 0;
                            }

                            callback();
                        });
                },
                setSortLogo(str_TF) {
                    return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;
                },
                addRecord() {
                    this.bool_isAMV = true;
                },
                addList() {
                    this.bool_isAMV1 = true;
                    this.accoutingItem = {
                        id: null,
                        description: '',
                        currency: '',
                        CI: null,
                        amount1: 0.00,
                        rate: 0.00,
                        quantity: 0,
                        amount2: 0.00,
                    };

                },
                DateTimeChange(type, event) {
                    if (type == "SD") {
                        var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                        var dateObj = new Date(momentObj);
                        if (dateObj != "Invalid Date" && event != "") {
                            this.searchCreatedTS.startDate = dateObj;
                        }
                        else if (event != "") {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                        } else {
                            this.searchCreatedTS.startDate = "";
                        }
                    }
                    if (type == "ED") {
                        var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                        var dateObj = new Date(momentObj);
                        if (dateObj != "Invalid Date" && event != "") {
                            this.searchCreatedTS.endDate = dateObj;
                        }
                        else if (event != "") {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                        } else {
                            this.searchCreatedTS.endDate = "";
                        }
                    }
                },
                clearDateRangeFilter() {
                    this.searchCreatedTS.startDate = this.getMonthStartDate();
                    this.searchCreatedTS.endDate = this.getMonthEndDate();
                },


            },
            created() {
                this.$parent.showSubMenu = 'R';
                this.$parent.showSubSubMenu = '';
                this.$parent.showActiveMenu = 'R.ACM';
                this.getSelectAgentgroup();
                this.calculateAndStoreAmount2();
            },
            watch: {
            },
        }

    </script>




// WEBPACK FOOTER //
// src/components/SideMenu/Reports/AccountingReport.vue